module.exports = __webpack_public_path__ + "img/13.51344db4.webp";